import getworkCategory from './get';
import updateworkCategory from './update';

export default [getworkCategory, updateworkCategory];
